import { useFeatureFlagsContext } from '@/contexts/FeatureFlagsContext';

export const useFeatureFlag = (key: string): boolean => {
  const { getFlag } = useFeatureFlagsContext();
  return getFlag(key);
};
